import { RouteProps } from '../../routes/AppRouter'
import { Circles as C } from '../../features/circles'
import React from 'react'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function Circles(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return (
    <>
      <C />
    </>
  )
}
